module.exports = __webpack_public_path__ + "static/media/game-2.e1ab5dc8.png";